import StimulusDialog from "@stimulus-components/dialog";

export default class Dialog extends StimulusDialog {
  // Function to override on open.
  open(event) {
    const eventId = event.detail?.id;
    const elementId = this.element?.id;

    // Logique pour afficher une modal spécifique
    // en ajoutant un id sur l'element et  dans le custom event
    // Le fait d'ajouter un id sur l'element HTML dialog attendra d'avoir un event.detail.id identique
    if (eventId) {
      if (eventId === elementId) {
        this.element.dispatchEvent(
          new CustomEvent("dialog:opened", {
            detail: { open: true }, // Données optionnelles
            bubbles: true, // Permet à l’événement de remonter dans le DOM
          })
        );
        super.open();
      }
    } else if (!elementId) {
      super.open();
    }
  }

  closeFromOutside(event) {
    if (!event) { this.close() }
    const eventId = event.detail?.id;
    const elementId = this.element?.id;
    if (eventId) {
      if (eventId === elementId) {
        this.element.dispatchEvent(
          new CustomEvent("dialog:closed", {
            detail: { closed: true }, // Données optionnelles
            bubbles: true, // Permet à l’événement de remonter dans le DOM
          })
        );
        this.close();
      }
    } else if (!elementId) {
      this.close();
    }
  }
}
